import { render, staticRenderFns } from "./chipDisplay.vue?vue&type=template&id=174d6324&"
import script from "./chipDisplay.vue?vue&type=script&lang=js&"
export * from "./chipDisplay.vue?vue&type=script&lang=js&"
import style0 from "./chipDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chipDisplay.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VChip,
  VIcon,
})
